namespace GeniuzPOS.PriceChange {
    export class ActivePriceChangeColumns {
        static columnsKey = 'PriceChange.ActivePriceChange';
    }
}
